import { render, staticRenderFns } from "./BuscaNomePlano.vue?vue&type=template&id=ab4c1994&scoped=true&"
import script from "./BuscaNomePlano.vue?vue&type=script&lang=js&"
export * from "./BuscaNomePlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4c1994",
  null
  
)

export default component.exports